export default "__VITE_ASSET__BHN8Gxh4__"